import { Component, OnInit } from '@angular/core';
import {TrackingComponent} from '@app/shared/components/tracking/tracking.component';
import {UrlService} from '@app/services/url.service';
import {FingerprintService} from '@app/services/fingerprint.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-most-popular-section',
  templateUrl: './most-popular-section.component.html',
  styleUrls: ['./most-popular-section.component.css']
})
export class MostPopularSectionComponent extends TrackingComponent implements OnInit {

  constructor(private urlService: UrlService,
              private fingerprintService: FingerprintService,
              private route: ActivatedRoute) { super(urlService, fingerprintService, null, route, 'stu_btn_market'); }

  ngOnInit(): void {
  }

}
